import { render, staticRenderFns } from "./px-tab-bar.vue?vue&type=template&id=7d1901ac&"
import script from "./px-tab-bar.vue?vue&type=script&lang=ts&"
export * from "./px-tab-bar.vue?vue&type=script&lang=ts&"
import style0 from "./px-tab-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports